// A3 — THE FIELD-ROW HELPERS. Brief 65 (brief 50 §4), the second of the sixteen.
//
// The three row builders every form modal in `App.tsx` is written with: a text
// field, a select, a textarea. They were declared twice — `QF`/`QS`/`QT` inside
// `renderQuickAddModal` and `F`/`S`/`T` inside `renderModals` — and the census
// pairs them at 90.3%, 86.4% and 88.7%. Every coordinate below carries the
// `@8fdbbd6c` marker coordinate-drift.js reads (its per-citation historical
// marker, never resolved) because they name where the code WAS and this commit
// is what stopped that being live:
//
//   src/App.tsx:6929-6940@8fdbbd6c x src/App.tsx:8767-8778@8fdbbd6c  90.3%  the text field
//   src/App.tsx:6941-6950@8fdbbd6c x src/App.tsx:8783-8792@8fdbbd6c  86.4%  the select
//   src/App.tsx:6951-6960@8fdbbd6c x src/App.tsx:8793-8802@8fdbbd6c  88.7%  the textarea
//
// WHAT DIFFERS, MEASURED: the two 32-line regions diff EMPTY once
// `quickAddForm` is renamed to `form` and `uqf` to `updateField`. Exactly two
// differences, and each becomes a PARAMETER rather than a choice (§2) — which
// form object is read, and which updater is called. Nothing is invented and
// neither copy's behaviour is preferred.
//
// A FACTORY RATHER THAN SIX PARAMETERS, because rule 3 is extract-don't-improve
// and there are ~90 call sites between the two modals. Closing over the four
// free names keeps every one of them byte-identical; widening each helper's
// signature would have rewritten all ninety.
//
// The seam is those four free names and no more (rule 2 — union, not select):
// the form object, its updater, the label translator `_fl`, and `t`. `_fl` is
// NOT extracted here: it is declared identically in both scopes but it is a
// different block, it pairs with nothing in the census, and this commit moves
// one candidate.
import FieldSelect from "../components/FieldSelect";
import { NO_AUTOFILL, noAutofillClass } from "./noAutofill"; // 213B §18 — no sign-ins, no contacts, in a form's field

export function makeFieldRows(ctx: any) {
  const { form, update, fl, t } = ctx;
  const F = (l?: any, k?: any, p?: any, a?: any) => (
    <div className="field">
      <label>{fl(l)}</label>
      <input
        {...NO_AUTOFILL}
        className={noAutofillClass("field-input")}
        value={form[k] || ""}
        onChange={(e) => update(k, e.target.value)}
        placeholder={p}
        autoFocus={a}
      />
    </div>
  );
  /* `ents` is optional because most of S()'s eight call sites are code-keyed
     lists (client type, reminder, task status, document status) where a
     value the list does not carry is still marked — that needs no
     vocabulary. It is passed by the two that are label-as-value. */
  const S = (l: any, k: any, opts: any, ents?: any) => (
    <FieldSelect
      label={fl(l)}
      value={form[k]}
      onChange={(v) => update(k, v)}
      options={opts}
      entries={ents}
      t={t}
    />
  );
  /* BRIEF 108 §8a — an optional height, defaulting to today's rendering:
     `rows={undefined}` is the attribute absent, so every two-argument call
     site (11 across the modals, censused in the commit) renders byte-
     identical. Only a caller that asks for a taller box gets one. */
  const T = (l: any, k: any, rows?: number) => (
    <div className="field">
      <label>{fl(l)}</label>
      <textarea
        {...NO_AUTOFILL}
        className={noAutofillClass("field-input")}
        value={form[k] || ""}
        onChange={(e) => update(k, e.target.value)}
        rows={rows}
      />
    </div>
  );
  return { F, S, T };
}
